module.exports = __webpack_public_path__ + "static/media/page_maker_coming_soon.76f4d942.svg";